export const storeBusinnesUnitTypes = new Map([
  ['ST', 'Operational Store'],
  ['DK', 'Dark Store'],
  ['DR', 'Dropped Project'],
  ['CN', 'Approved But Not Open'],
  ['HO', 'Home Office'],
]);
